// IMPORTS
import { Link } from 'react-router-dom';
import Button from './Button';

// CONPONENT
const AddContent = () => (
  <div className="flex-auto p-5">
    <h1 className="my-3 font-bold">Add/Update Content</h1>
    <Link to="/add-doctor">
      <Button label="Add Doctor" className="flex-auto mx-2 px-2 bg-indigo1 round text-white" onClick={() => console.log('Button clicked')} />
    </Link>
    <Link to="/update-doctor">
      <Button label="Update Doctor's Atrributes" className="flex-auto m-2 px-2 bg-indigo1 round text-white" onClick={() => console.log('Button Clicked')} />
    </Link>
    <Link to="/find-doctor-by-order">
      <Button label="Find Doctor by Doctor's Order" className="flex-auto m-2 px-2 bg-indigo1 round text-white" onClick={() => console.log('Button Clicked')} />
    </Link>
  </div>
);

// EXPORT
export default AddContent;
